<!-- <app-lifestyle></app-lifestyle> -->

<div class="col-md-12 row clear-all flow-content">
  <div class="container m-auto">
    <div class="col-md-12 clear-all">
      
        <div class="row dummy"></div>
          <!-- <div class="col-md-2 marginLeft marginTop"> -->
     
      <div class="col-md-10 clear-all margin-left wd-10">
          <!-- <div class="col-md-10 padding-left-0 content-wrapper"> -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>